var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.313,
    viewBox: "0 0 22 21.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1794.344 -365.451)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2020.188,437.423l2.676-2.049v-1.823l-2.676-1.823Z",
    transform: "translate(-206.521 -60.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1884.478,367.721h6.621l-3.332-2.271Z",
    transform: "translate(-82.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1794.344,437.084l2.554,1.955V433.6l-2.554,1.763Z",
    transform: "translate(0 -62.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1833.2,401v8.821l5.244,4.014,2.434-1.46a.387.387,0,0,1,.4,0l2.169,1.348,4.979-3.811V401Zm13.317,8.45h-11.688a.385.385,0,1,1,0-.771h11.688a.385.385,0,0,1,0,.771Zm0-3.009h-11.688a.385.385,0,1,1,0-.771h11.688a.385.385,0,0,1,0,.771Zm-9.169-3.189h9.169a.385.385,0,0,1,0,.771h-9.169a.385.385,0,1,1,0-.771Z",
    transform: "translate(-35.535 -32.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1794.344,496.418l7.858-4.715-7.858-6.015Z",
    transform: "translate(0 -109.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1961.166,491.6l7.726,4.8V485.688Z",
    transform: "translate(-152.548 -109.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1816.3,543.081l-10.191,6.115h20.028Z",
    transform: "translate(-10.755 -162.432)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ce67799144279f4af8739d1f637bf9da.svg";
export { ForwardRef as ReactComponent };